'use client';

import a__default, { forwardRef } from "react";
import { Button } from "../../atoms/Button/Button.js";
import { DotsThreeVertical } from "../../../react-icons.js";
function ActionMenuTriggerComponent({ children, ...rest }, ref) {
  return /* @__PURE__ */ a__default.createElement(Button, { ...rest, icon: DotsThreeVertical, ref, hiddenLabel: true }, children);
}
const ActionMenuTrigger = forwardRef(ActionMenuTriggerComponent);
export {
  ActionMenuTrigger
};
